// Defines playlists in a scene

import { newPlaylist, radioConfig } from "../configHelpers";
import { PLAYLIST } from "./playlistConfig";

export const SCENE_AUDIO = Object.freeze({
	SPLASH_SCREEN: {
		radios: radioConfig({ GLOBAL: 1 }),
		playlists: [],
	},
	CABIN_HUB: {
		radios: radioConfig({ GLOBAL: 1, CABIN: 0.4 }),
		playlists: [newPlaylist(PLAYLIST.FIREPLACE, 0.4, true, "FIREPLACE")],
	},
	RADIO: {
		radios: radioConfig({ GLOBAL: 1, CABIN: 0.8 }),
		playlists: [newPlaylist(PLAYLIST.FIREPLACE, 0.5, true, "FIREPLACE")],
	},
	GAME_TABLE: {
		radios: radioConfig({ GLOBAL: 1, CABIN: 0.5 }),
		playlists: [newPlaylist(PLAYLIST.FIREPLACE, 0.4, true, "FIREPLACE")],
	},
	FIREPLACE: {
		radios: radioConfig({ GLOBAL: 1, CABIN: 0.8 }),
		playlists: [newPlaylist(PLAYLIST.FIREPLACE, 0.5, true, "FIREPLACE")],
	},
	FIREPLACE_CLOSE: {
		radios: radioConfig({ GLOBAL: 1, CABIN: 1 }),
		playlists: [newPlaylist(PLAYLIST.FIREPLACE, 0.7, true, "FIREPLACE")],
	},
	CAT: {
		radios: radioConfig({ GLOBAL: 1, CABIN: 1 }),
		playlists: [
			// newPlaylist(PLAYLIST.CAT, 0.5, false, "CAT"),
			newPlaylist(PLAYLIST.FIREPLACE, 0.9, true, "FIREPLACE"),
		],
	},
	COUCH: {
		radios: radioConfig({ GLOBAL: 1, CABIN: 0.8 }),
		playlists: [newPlaylist(PLAYLIST.FIREPLACE, 0.2, true, "FIREPLACE")],
	},
	WINDOW: {
		radios: radioConfig({ GLOBAL: 1, CABIN: 0.8 }),
		playlists: [
			newPlaylist(PLAYLIST.FIREPLACE, 0.2, true, "FIREPLACE"),
			newPlaylist(PLAYLIST.LAKESIDE, 0.2, true, "LAKE"),
		],
	},
	LIBRARY: {
		radios: radioConfig({ GLOBAL: 1, CABIN: 0.8 }),
		playlists: [newPlaylist(PLAYLIST.FIREPLACE, 0.4, true, "FIREPLACE")],
	},
	DESK: {
		radios: radioConfig({ GLOBAL: 1, CABIN: 0.8 }),
		playlists: [newPlaylist(PLAYLIST.FIREPLACE, 0.4, true, "FIREPLACE")],
	},

	DESK_DRAWER: {
		radios: radioConfig({ GLOBAL: 1, CABIN: 0.8 }),
		playlists: [newPlaylist(PLAYLIST.FIREPLACE, 0.4, true, "FIREPLACE")],
	},
	CABIN_EXIT: {
		radios: radioConfig({ GLOBAL: 1, CABIN: 0.8 }),
		playlists: [newPlaylist(PLAYLIST.FIREPLACE, 0.4, true, "FIREPLACE")],
	},
	CABIN_KITCHEN: {
		radios: radioConfig({ GLOBAL: 1, CABIN: 0.8 }),
		playlists: [newPlaylist(PLAYLIST.FIREPLACE, 0.4, true, "FIREPLACE")],
	},
	PLANE: {
		radios: radioConfig({ GLOBAL: 1, CABIN: 0 }),
		playlists: [newPlaylist(PLAYLIST.PLANE, 0.4, false, "PLANE")],
	},
	CABANA: {
		radios: radioConfig({ GLOBAL: 1, CABIN: 0 }),
		playlists: [newPlaylist(PLAYLIST.OCEAN, 0.4, true, "OCEAN")],
	},
	CABANA_BEACH: {
		radios: radioConfig({ GLOBAL: 1, CABIN: 0 }),
		playlists: [newPlaylist(PLAYLIST.OCEAN, 0.7, true, "OCEAN")],
	},
	PLANE_RETURN: {
		radios: radioConfig({ GLOBAL: 1, CABIN: 0 }),
		playlists: [newPlaylist(PLAYLIST.PLANE, 0.4, false, "PLANE")],
	},
});
